module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Bold.637ed948.ttf";